import { Component, Input } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-spinner',
  imports: [TegelModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {
  @Input() size = 'lg';
  @Input() variant = 'standard';
  @Input() overlay = true;
}
